import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';

import { AutofocusDirective, SettingsFormComponent, VMPFormGroupComponent, VMPFormGroupItemComponent, VMPLabelComponent } from './forms';
import {
  ButtonEditComponent,
  CheckEditComponent,
  LookupEditComponent,
  SelectEditComponent,
  TextEditComponent,
  ToggleEditComponent,
} from './editors';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SafeHtmlPipe, SafeUrlPipe } from './pipes';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [
    SafeHtmlPipe,
    SafeUrlPipe,
    ButtonEditComponent,
    CheckEditComponent,
    LookupEditComponent,
    SelectEditComponent,
    TextEditComponent,
    ToggleEditComponent,
    SettingsFormComponent,
    VMPFormGroupComponent,
    VMPLabelComponent,
    VMPFormGroupItemComponent,
    AutofocusDirective,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatListModule,
    MatGridListModule,
    MatTooltipModule,
    MatButtonModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    TranslateModule,
    MatCheckboxModule,
    MatProgressBarModule
  ],
  exports: [
    SafeHtmlPipe,
    SafeUrlPipe,
    ButtonEditComponent,
    CheckEditComponent,
    LookupEditComponent,
    SelectEditComponent,
    TextEditComponent,
    ToggleEditComponent,
    SettingsFormComponent,
    VMPFormGroupComponent,
    VMPFormGroupItemComponent,
    VMPLabelComponent,
    AutofocusDirective,
  ],
})
export class RoesbergModule {}

export * from './enums';
export * from './helper';
export * from './models';
